import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';

import IconMC from '../../../../../components/IconMC';
import SendPDFAction from './SendPDFAction';
import SendPaymentLinksAction from './SendPaymentLinksAction';
import SendByAction from './SendByAction';

const OrderSuccessSection = ({
  order,
  action,
  platform,
  onSendPaymentLink,
  onSendPdf,
  closeParentModal
}) => {
  const { t } = useTranslation('Orders');

  const title = action === 'create'
    ? t('orderSaved.createTitle')
    : t('orderSaved.updateTitle');

  const description = action === 'create'
    ? t('orderSaved.createDesc')
    : t('orderSaved.updateDesc');

  return (
    <div className="tw-wrapper">
      <div className="tw-flex tw-flex-col tw-py-[50px] tw-items-center">
        <IconMC
          name="checkmark-circle-2-fill"
          className="tw-text-green-400 !tw-size-[83px]"
        />

        <p className="tw-font-semibold tw-text-blue-500 tw-text-sm tw-mb-0">
          {title}
        </p>
        <p className="tw-text-center tw-mb-0">{description}</p>

        <div className="tw-flex tw-gap-6 tw-mt-6">
          {platform !== 'instagram' && (
            <SendPDFAction
              order={order}
              closeParentModal={closeParentModal}
              onSendPdf={onSendPdf}
            />
          )}
          <SendPaymentLinksAction
            order={order}
            platform={platform}
            onSendPaymentLink={onSendPaymentLink}
            closeParentModal={closeParentModal}
          />
          <SendByAction
            order={order}
            platform={platform}
            onSendPaymentLink={onSendPaymentLink}
            closeParentModal={closeParentModal}
          />
        </div>
      </div>
    </div>
  );
};

export default memo(OrderSuccessSection);
